import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

// Wraps a branch of routes. Redirects to login if there is no session,
// and redirects to the correct home if the signed in user's role does not
// belong on this branch (e.g. a client hitting /dashboard/agency).
export function RequireAuth({ allowedRoles }) {
  const { session, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
        Loading...
      </div>
    );
  }

  if (!session || !profile) {
    return <Navigate to="/dashboard/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(profile.role)) {
    const home = profile.role === "client" ? "/dashboard/client" : "/dashboard/agency";
    return <Navigate to={home} replace />;
  }

  return <Outlet />;
}
